import { render } from "./QuestionBank.vue?vue&type=template&id=66a0969b&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"

import "./QuestionBank.vue?vue&type=style&index=0&id=66a0969b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a0969b"]])

export default __exports__